import { useMemo } from "react";
import type { WorkspaceSchema } from "@common/schemas/workspace.schema";
import { useBaseWorkspacesDetailsQuery } from "@api/workspace.api";
import {
    buildWorkspaceMembersMap,
    computeDefaultClientIdsByWorkspaceId,
} from "./applyCloseTemplateOrganizationMembers";

interface Params {
    organizationId: string | null | undefined;
    workspaces: WorkspaceSchema[] | undefined;
}

export function useApplyCloseTemplateWorkspaceMembers({
    organizationId,
    workspaces,
}: Params) {
    const organizationWorkspaceIds = useMemo(
        () => workspaces?.map((workspace) => workspace.id) ?? [],
        [workspaces],
    );

    const { data: workspaceDetailsData } = useBaseWorkspacesDetailsQuery({
        organizationId: organizationId ?? undefined,
    });

    const workspaceMembersMap = useMemo(
        () =>
            buildWorkspaceMembersMap(
                organizationWorkspaceIds,
                workspaceDetailsData?.data,
            ),
        [organizationWorkspaceIds, workspaceDetailsData?.data],
    );

    const defaultClientIdByWorkspaceId = useMemo(
        () => computeDefaultClientIdsByWorkspaceId(workspaceMembersMap),
        [workspaceMembersMap],
    );

    return {
        organizationWorkspaceIds,
        workspaceMembersMap,
        defaultClientIdByWorkspaceId,
    };
}
